// Textos del inicio (guía, sección 8.1). Son finales: si algo se acorta por diseño,
// se anota en la bitácora.

// Alternativas de claim para que Juan Manuel elija (guía 8.1). Para cambiarlo, basta
// con cambiar `selectedClaim`. El <h1> y la letra chica se arman a partir de acá.
export const claimOptions = {
  latinoamerica: "El primer modelo de lenguaje de Latinoamérica con arquitectura propia.",
  hispanohablante: "El primer modelo de lenguaje del mundo hispanohablante con arquitectura propia.",
  paraguay: "Inteligencia artificial diseñada en Paraguay. Desde cero.",
} as const;

export const selectedClaim: keyof typeof claimOptions = "latinoamerica";

export const home = {
  opening: {
    word: "YvyrAI",
    line: "Laboratorio de inteligencia artificial · Asunción, Paraguay",
  },
  claim: {
    text: claimOptions[selectedClaim],
    fineprint: "Hasta donde pudimos verificar entre 25.700 modelos publicados.",
    cta: { label: "Cómo lo comprobamos", href: "/auditoria" },
  },
  what: {
    body: "Lo diseñamos en Asunción y lo entrenamos desde la primera línea. No hereda nada de Llama, de Qwen ni de ningún otro modelo.",
    second: "Los pesos son públicos. Cualquiera puede descargarlos y comprobarlo.",
  },
  thinks: {
    title: "Piensa antes de responder.",
    body: "Un modelo común contesta de una sola pasada. El nuestro vuelve sobre su respuesta varias veces antes de darla, estima qué tan seguro está y decide solo cuándo terminó de pensar.",
    figure: "−29,5 %",
    // La etiqueta se arma alrededor de la palabra con ayuda (ver HomeFilm).
    figureLabel: { before: "de ", term: "perplejidad", after: " entre una y siete vueltas, medido sobre el mismo modelo." },
    termHelp: "Mide cuánto duda un modelo al predecir la palabra siguiente. Menos es mejor.",
    counter: "vuelta",
    verified: "verificado",
    cta: { label: "Cómo funciona", href: "/investigacion" },
  },
  sky: {
    figure: "25.700",
    body: "Revisamos los modelos de lenguaje publicados en Latinoamérica, Brasil y España. Casi todos parten de Llama, Qwen, Mistral u otra familia conocida.",
    punch: "Con arquitectura propia, encontramos uno.",
    /** Rótulos en el cielo durante el remate: el punto nuestro y el resto. */
    marks: { ours: "YvyrAI · arquitectura propia", crowd: "Llama, Qwen, Mistral y otras familias" },
    cta: { label: "Ver la auditoría", href: "/auditoria" },
  },
  products: {
    eyebrow: "Productos",
    title: "Yvyra atiende. Tajy mira.",
    yvyra: "Contesta el WhatsApp de tu negocio con tu catálogo y tus precios, lleva el stock y te avisa antes de que algo se venza.",
    tajy: "Ve lo que pasa en tu local: caídas, aforo y mermas. El video nunca sale de tu negocio.",
    cta: { label: "Ver productos", href: "/productos" },
  },
  open: {
    title: "Abierto para que lo revises.",
    body: "Publicamos los pesos del modelo, el código para usarlo y el paper. Preferimos que nos verifiquen a que nos crean.",
    links: [
      { label: "Pesos en Hugging Face", detail: "Apache 2.0", href: "https://huggingface.co/Manuel12435/YvyrAI-100m-Nano" },
      { label: "Paper (DOI)", detail: "10.5281/zenodo.20533759", href: "https://doi.org/10.5281/zenodo.20533759" },
      { label: "Auditoría", detail: "≈ 25.700 modelos", href: "/auditoria" },
    ],
  },
  media: {
    eyebrow: "En los medios",
    cta: { label: "Sala de prensa", href: "/prensa" },
  },
  next: {
    title: "Esto recién empieza.",
    cta: { label: "Ver modelos", href: "/modelos" },
  },
  close: {
    title: "Construyamos lo que sigue.",
    body: "Si tenés un negocio, una institución o una idea que necesita inteligencia artificial, escribinos.",
    primary: "Escribinos por WhatsApp",
    secondary: { label: "Otras formas de contacto", href: "/contacto" },
  },
} as const;

// El <h1> real de la página (guía 8.1) es "YvyrAI, el primer modelo de lenguaje de
// Latinoamérica con arquitectura propia": un solo <h1>, repartido entre el bloque 1
// (la palabra) y el bloque 2 (el claim). En el HTML el claim va en minúscula y sin
// punto final para que el <h1> se lea como una sola frase; la mayúscula y el punto
// visibles los pone el CSS.
export function homeH1Parts() {
  const claim = home.claim.text.replace(/\.\s*$/, "");
  const continuation = claim.charAt(0).toLowerCase() + claim.slice(1);
  return { word: home.opening.word, continuation };
}
